import {Injectable} from "@angular/core";
//import {BaseService} from "../base.service";
import {Environment} from "../environment-core";

declare var OpenPay;

@Injectable()
export class OpenPayService{// extends BaseService {

  private _deviceSessionId: string;


  get deviceSessionId(): string {
    return this._deviceSessionId;
  }

  constructor(environment: Environment) {
    //super(environment);
    let devMode = environment.devMode;
    console.log('mostramos si estamos en modo dev',devMode);

    if(devMode){
      OpenPay.setId('mpripizokjynemqrd7sa');
      OpenPay.setApiKey('pk_8401a106f8e2476983e3a67f99ae8812');
      OpenPay.setSandboxMode(true);
    } else {
      OpenPay.setId('m88xzfgwxh1hms129ijo');
      OpenPay.setApiKey('pk_b88f9cc16a5647c898db44b5d862e960');
      OpenPay.setSandboxMode(false);
    }

    this._deviceSessionId = OpenPay.deviceData.setup();
  }

  createCardToken(cardInfo: any): Promise<any> {
    let cardInfoCopy = Object.assign({}, cardInfo);

    return new Promise<any>((resolve, reject) => {
      OpenPay.token.create(cardInfo,
        response => resolve(response),
        error => {
          return reject(JSON.stringify(error));
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/core/openpay/openpay.service.ts